<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm7>
              <div class="x-text-field">
                <label>奖励名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm5>
              <div class="x-text-field">
                <label>校内主管部门</label>
                <div>{{item.adminDept? item.adminDept.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>获奖人列表</label>
                <div>
                  <v-data-table
                    class="dense"
                    :headers="headers"
                    :items="item.awardees"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.rank}}</td>
                      <td>{{props.item.name}}</td>
                      <td>{{props.item.certificateNo}}</td>
                      <td>{{props.item.deptName}}</td>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>奖励成果</label>
                <div>{{item.achievement}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>奖励类型</label>
                <div>{{item.type.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>奖励级别</label>
                <div>{{item.level.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>奖励等级</label>
                <div>{{item.grade.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>证书编号</label>
                <div>{{item.certificateNo}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3>
              <div class="x-text-field">
                <label>单位排名</label>
                <div>{{item.institutionRank === 0? '未署名': `第${item.institutionRank}单位`}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3>
              <div class="x-text-field">
                <label>获奖日期</label>
                <div>{{item.grantDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{item.department.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>所属学科</label>
                <div>{{item.subject.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/awar/file/${a.dbid}`" target="_blank">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/awar/award';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        item: {
          "type": {},
          "level": {},
          "grade": {},
          "department": {},
          "subject": {}
        },

        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '姓名', sortable: false, value: 'name'},
          {text: '证书编号', sortable: false, value: 'certificateNo'},
          {text: '单位', sortable: false, value: 'rank'},
        ]
      }
    }
  }
</script>
